import { extendTailwindMerge, twJoin } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        "brand",
        "brand-secondary",
        "brand-hover",
        "black",
        "light-gray",
        "medium-gray",
        "gray",
        "warning",
        "error",
        "info",
        "success",
        "white",
        "background",
        "transparent",
        "tags-blue",
        "tags-red",
        "tags-green",
        "tags-yellow",
        "tags-purple",
        "accent-light-blue",
        "accent-light-red",
        "accent-light-green",
        "accent-light-yellow",
        "accent-light-purple",
      ],
      "font-weight": ["regular", "semibold"],
      text: ["extraSmall", "small", "normal", "base", "large", "extraLarge", "huge", "enormous", "screenTitle"],
      shadow: ["up", "down", "back", "top"],
    },
  },
});

export const cn = twMerge;
export const cx = twJoin;
